import React, { FC } from 'react';
import { formatDate } from '@factorin/util/lib';

import { Box, Stack, Typography, useDesktop } from 'Modules/ui3';
import { setHtml } from 'Modules/ui';

import { useNavigate } from '../../utils';
import { NewsPaginationElement } from '../../api';
import { NewsTag } from '../NewsTag';


export type NewsPreviewProps = Omit<NewsPaginationElement, 'Img'>

export const NewsPreview: FC<NewsPreviewProps> =
({ Date, Description, Id, Tags = [], Title }) => {
    const goToDetail = useNavigate(`/news/${Id}`);
    const isDesktop = useDesktop();
    return (
        <>
            <Stack direction='row' alignItems='flex-end' spacing={4}>
                {Tags.map((tag, idx) => (
                    <NewsTag key={`${tag}_${idx}`} tag={tag} />
                ))}
            </Stack>
            <Box flex={1} py={isDesktop ? 5 : 4}>
                <Typography
                    component='div'
                    display='-webkit-box'
                    variant={isDesktop ? 'mediumHeader2' : 'mediumBody2'}
                    lineHeight='1.5'
                    color='grayscale.shade95'
                    maxHeight={isDesktop ? '60px' : '48px'}
                    textOverflow='ellipsis'
                    overflow='hidden'
                    title={Title}
                    sx={{
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                    {...setHtml(Title)}
                />
                <Stack spacing={isDesktop ? 4 : 3} mt={isDesktop ? 3 : 1}>
                    <Typography
                        component='div'
                        variant='regularCaption2'
                        lineHeight='1.3'
                        color='grayscale.shade90'
                    >
                        {formatDate(Date)}
                    </Typography>
                    <Typography
                        component='div'
                        display='-webkit-box'
                        variant={isDesktop ? 'regularBody2' : 'regularCaption2'}
                        lineHeight={isDesktop ? '1.5' : '1.4'}
                        maxHeight={isDesktop ? '104px' : '68px'}
                        textOverflow='ellipsis'
                        overflow='hidden'
                        color='grayscale.shade95'
                        sx={{
                            WebkitLineClamp: 4,
                            WebkitBoxOrient: 'vertical',
                        }}
                        {...setHtml(Description)}
                    />
                </Stack>
            </Box>
            <Typography
                component='a'
                onClick={goToDetail}
                variant={isDesktop ? 'regularBody2' : 'regularCaption2'}
                lineHeight={isDesktop ? '1.5' : '1.4'}
                sx={{
                    cursor: 'pointer',
                }}
            >
                Читать полностью
            </Typography>
        </>
    );
};
